import { render, staticRenderFns } from "./AppNotificationBubble.vue?vue&type=template&id=69a0f2d8&scoped=true&"
import script from "./AppNotificationBubble.vue?vue&type=script&lang=js&"
export * from "./AppNotificationBubble.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationBubble.vue?vue&type=style&index=0&id=69a0f2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a0f2d8",
  null
  
)

export default component.exports